import { Card } from "antd";

interface AdditionalSkincareNotesProps {
  data?: any;
}

const AdditionalSkincareNotes: React.FC<AdditionalSkincareNotesProps> = ({
  data,
}) => {
  return (
    <div className="additional-skincare-notes">
      <Card>
        <h3 className="title">Additional 📌 Skincare Notes</h3>
        <ul>
          {data &&
            data.map((item: any, i: number) => {
              return <li key={i} dangerouslySetInnerHTML={{ __html: item }} />;
            })}
        </ul>
      </Card>
    </div>
  );
};

export default AdditionalSkincareNotes;
